import { useState, useContext, useEffect } from "react"
import { CommaFire, CSkeletonPlan, toast } from "../../components/widget"
import { ContextNav, ContextAbsence, ContextLoading, ContextDashboard } from "../../context";
import { useSearchParams, Link } from 'react-router-dom'
import { StringDecoder } from "string_decoder";

export const ModuleResult = () => {
    const [searchParams] = useSearchParams();
    const CtxNav = useContext(ContextNav)
    const CtxLoad = useContext(ContextLoading)
    const CtxDash = useContext(ContextDashboard)
    const [status, setStatus] = useState(0)
    const [statusMessag, setStatusMessag] = useState<any>(null)



    useEffect(() => {
        document.title = "  نتیجه پرداخت | دایان"
        CtxNav.setActiveMenuItem({ 'item': -1, 'subItem': 0, })
    }, [])
    
    useEffect(() => {
        if (searchParams.get('status') != null && searchParams.get('status') == 'true') {
            setStatus(1)
            setStatusMessag(searchParams.get('status_messag'))
        }
        if (searchParams.get('status') != null && searchParams.get('status') == 'false') {
            setStatus(2)
        }
    }, [searchParams])

    return (
        <div className=" w-full flex flex-col">
            <div className=" w-full flex flex-wrap ">
                <div className={`w-full py-3 bg-white rounded-lg shadow flex flex-col justify-center items-center `}>

                    {status == 1 &&
                        <div className=' w-[90%] sm:w-[500px]  border border-[#0aa06e] rounded py-[20px] m-auto my-[100px] flex flex-col justify-center items-center'>
                            <img src={'/assetes/media/success.png'} alt=" success" className=' w-[60px]' />
                            <span className='mt-[15px]'>ماژول موردنظر با موفقیت فعال شد</span>
                            <span className='mt-[15px] text-gray-500 text-xl'>کد رهگیری : {statusMessag}</span>
                            <div className=' w-full flex justify-around mt-[40px]'>
                                <Link to={'/p/module'}>
                                    <button className=' w-[200px] h-[40px] text-white rounded bg-[#0aa06e]'>ماژول ها</button>
                                </Link>
                            </div>
                        </div>
                    }

                    {status == 2 &&
                        <div className=' w-[90%] sm:w-[500px]  border border-[#f74663] rounded py-[20px] m-auto my-[100px] flex flex-col justify-center items-center'>
                            <img src={'/assetes/media/fail.png'} alt=" fail" className=' w-[60px]' />
                            <span className='mt-[15px]'>در پرداخت ماژول شما خطایی رخ داده است</span>
                            <span className='mt-[15px]'>مجدد تلاش فرمایید</span>
                            <div className=' w-full flex justify-around mt-[40px]'>
                                <Link to={'/p/module'}>
                                    <button className=' w-[200px] h-[40px] text-white rounded bg-[#f74663]'>بازگشت</button>
                                </Link>
                            </div>
                        </div>
                    }

                </div>
            </div>
        </div>
    )
}
